<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getJobListFromFilter" :items-per-page="40" :filter="filter"
    :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id" textkey="DisplayName"
    :label="label ? label : $t('servicesystem.common_objects.job.job')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.job.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$job</v-icon>
    </template>
    <!-- 
    <template v-if="!multiple && showcase" v-slot:selection="{ item }">
      <JobLi :jobItem="item" previewMode />
    </template>
    -->
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";
//import JobLi from "@/components/ListItems/JobListItem/JobListItem.vue";

export default {
  name: "JobSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    hideIcon: Boolean,
    showcase: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
    //JobLi,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>